import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import HeroSection from './components/HeroSection';
import PilaresSection from './components/PilaresSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import ClientesSection from './components/ClientesSection';
import InstitucionalSection from './components/InstitucionalSection';
import CTASection from './components/CTASection';

const SCHEMA_HOME = JSON.stringify({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
      name: 'Engeporto Engenharia e Serviços Ltda.',
      url: import.meta.env.VITE_SITE_URL,
      logo: `${import.meta.env.VITE_SITE_URL}/logo.png`,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+55-15-99671-9308',
        contactType: 'customer service',
        areaServed: 'BR',
        availableLanguage: 'Portuguese',
      },
      sameAs: [],
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${import.meta.env.VITE_SITE_URL}/#localbusiness`,
      name: 'Engeporto Engenharia e Serviços Ltda.',
      description: 'Referência em Prevenção de Incêndio (AVCB, CLCB), Segurança do Trabalho (PGR, LTCAT) e Perícias Técnicas nas Regiões Metropolitanas de Sorocaba e Campinas.',
      url: import.meta.env.VITE_SITE_URL,
      telephone: '+55-15-99671-9308',
      email: 'engeporto.contato@gmail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Rua Floriano Pires, 103',
        addressLocality: 'Porto Feliz',
        addressRegion: 'SP',
        postalCode: '18545-060',
        addressCountry: 'BR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: -23.2147,
        longitude: -47.5244,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '08:00',
          closes: '12:00',
        },
      ],
      priceRange: '$$',
      areaServed: ['Sorocaba', 'Campinas', 'Porto Feliz'],
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'Engeporto Engenharia',
      inLanguage: 'pt-BR',
    },
  ],
});

const HomePage = () => {
  useEffect(() => {
    document.title =
      'Engeporto Engenharia Sorocaba Campinas | AVCB, CLCB, Segurança do Trabalho e Perícias';
    const setMeta = (name: string, content: string, prop = false) => {
      const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      const el = document.querySelector(sel) as HTMLMetaElement | null;
      if (el) el.setAttribute('content', content);
    };
    setMeta('description', 'Engeporto Engenharia — referência em Prevenção de Incêndio (AVCB, CLCB), Segurança do Trabalho (PGR, LTCAT) e Perícias Técnicas nas Regiões Metropolitanas de Sorocaba e Campinas. CREA-SP 5071305786.');
    setMeta('keywords', 'AVCB Sorocaba, CLCB Campinas, segurança do trabalho, PGR, LTCAT, perícia técnica engenharia, prevenção de incêndio');
    setMeta('og:title', 'Engeporto Engenharia Sorocaba Campinas | AVCB, CLCB, Segurança do Trabalho e Perícias', true);
    setMeta('og:description', 'Referência em Prevenção de Incêndio, Segurança do Trabalho e Perícias Técnicas em Sorocaba e Campinas.', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL}/`, true);
    setMeta('og:image', `${import.meta.env.VITE_SITE_URL}/og-image.jpg`, true);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
    return () => { canonical?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: SCHEMA_HOME }}
      />
      <Navbar />
      <HeroSection />
      <PilaresSection />
      <DiferenciaisSection />
      <ClientesSection />
      <InstitucionalSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default HomePage;